import * as React from "react";
import * as field from "./field";
import * as validation from "./validation/validation";
import * as csstips from 'csstips';
import * as styles from "../base/styles";
import * as typestyle from 'typestyle';
import { Input, InputType, Checkbox, TextArea } from "../base/input";
import { Label, LabelStyles } from '../base/label';
import { observer } from 'mobx-react';
import { AddressLookup } from '../../pages/components/address/AddressLookup';
import { FieldErrorText } from "./field";

export const TextInputField = (props: field.FieldPropsWithoutInput<string> & { type?: InputType, autoFocus?: boolean }) => {
  const InputField = field.Field as { new (): field.Field<string> };

  let input = (fieldProps: field.InputProps<string>) => (
    <Input
      id={fieldProps.id}
      name={fieldProps.name}
      value={fieldProps.value}
      onChange={fieldProps.onChange}
      error={fieldProps.error}
      readOnly={fieldProps.readOnly}
      takeFocus={fieldProps.takeFocus}
      type={props.type}
      autoFocus={props.autoFocus}
      onKeyDown={props.onKeyDown}
      onKeyUp={props.onKeyUp}
      onKeyPress={props.onKeyPress}
    />
  );

  return <InputField {...props} {...{ input }} />;
};



/** Address Lookup input field */
export const AddressLookupInputField = observer(
  (props:  field.FieldPropsWithoutInput<string>
    & { takeFocus: boolean,
        switchToManual: () => void,
        lookupFailureHandler: () => void
      }
  ) => {
  // Add the types
  const InputField = field.Field as { new (): field.Field<string> };

  // Add the input
  let input = (fieldProps: field.InputProps<string>) =>
    <AddressLookup
      id="client-address"
      switchToManual={props.switchToManual}
      lookupFailureHandler={props.lookupFailureHandler}
      takeFocus={props.takeFocus}
    />

  let theInput = { input };

  return <InputField {...props} {...theInput} />
});

/** Text area field */
export const TextAreaField = (props: field.FieldPropsWithoutInput<string> & { type?: InputType, autoFocus?: boolean }) => {
  // Add the types
  const InputField = field.Field as { new (): field.Field<string> };

  // Add the input
  let input = (fieldProps: field.InputProps<string>) =>
    <TextArea
      id={fieldProps.id}
      name={fieldProps.name}
      value={fieldProps.value}
      onChange={fieldProps.onChange}
      error={fieldProps.error}
      readOnly={fieldProps.readOnly}
      type={props.type}
      autoFocus={props.autoFocus}
      />
  let theInput = { input };


  return <InputField {...props} {...theInput} />
};

/**
 * CheckboxFieldStyles
 */
export namespace CheckboxFieldStyles {
  export const rootClassName = typestyle.style(
    csstips.flex,
    csstips.flexRoot,
    csstips.vertical
  );
}

/**
 * The checkbox field is layed out differently then other fields in that the label is on the right instead of top
 * So we don't actually use the layout provided by `Field` in this component and have our own `render`` function
 */
export class CheckboxField extends React.Component<field.FieldPropsWithoutInput<boolean>, {}> {
  render() {
    const inputProps = field.getPropsForInput(this.props);
    const className = typestyle.classes(LabelStyles.rootClass, this.props.fieldState.error && LabelStyles.errorClass);

    const checkbox = <Checkbox
      id={inputProps.id}
      name={inputProps.name}
      disabled={!!inputProps.readOnly}
      value={inputProps.value}
      onChange={inputProps.onChange}
      />

    const checkboxAndLabel = this.props.label
      ? <label htmlFor={this.props.id} className={className}>
        {checkbox} {this.props.label}
      </label>
      : checkbox;

    return (
      <div className={CheckboxFieldStyles.rootClassName}>
        {checkboxAndLabel}
        {
          this.props.fieldState.error
          && <div className={field.FieldStyles.errorTextClassName}>
            {this.props.fieldState.error}
          </div>
        }
      </div>
    );
  }
}

export default observer(CheckboxField);
